import React from 'react';
import { GlobeIcon, LockIcon, PackageIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CheckList } from './CheckList';
import { CtaButton } from './CtaButton';
import { fullPrice, heroImage, price, productName, savings, savingsPercent } from '../data/copy';
const packageItems = ['6 Complete Volumes', '150+ Sessions', '5 Command Kits', 'Tier 1 → Tier 3', 'Printable PDF', 'Lifetime Updates'];
const security = [{
  icon: LockIcon,
  label: 'Secure'
}, {
  icon: ZapIcon,
  label: 'Instant access'
}, {
  icon: ShieldCheckIcon,
  label: '7-day guarantee'
}, {
  icon: GlobeIcon,
  label: 'Local currency'
}];

/** The whole offer fits in one mobile screen: what, price, action. */
export function OfferSection() {
  return <section id="offer" className="defer-paint w-full scroll-mt-4 bg-white py-10 sm:py-20" aria-labelledby="offer-heading" data-id="element-169" data-mp="wchgot2hi4hy">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-170" data-mp="2t7dtkcu4tdvn">
        <h2 id="offer-heading" className="text-center font-display text-2xl font-bold leading-tight text-navy sm:text-4xl lg:text-5xl" data-id="element-171" data-mp="2y5fdt13anj8p">
          Your Complete <span className="text-gold-text" data-id="element-172" data-mp="12pcv0qrhnntc">6-Volume</span> System
          Today
        </h2>

        <div className="relative mx-auto mt-7 max-w-lg rounded-3xl border-2 border-navy bg-white p-5 text-center shadow-2xl shadow-navy/10 sm:mt-12 sm:p-8" data-id="element-173" data-mp="xuyyum505cnm">
          <span className="absolute left-1/2 top-0 inline-flex -translate-x-1/2 -translate-y-1/2 items-center gap-1.5 whitespace-nowrap rounded-full bg-gold px-3.5 py-1 text-[11px] font-extrabold uppercase tracking-wider text-navy" data-id="element-174" data-mp="oxeuv5fr929b">
            <PackageIcon className="h-3.5 w-3.5" strokeWidth={2.5} aria-hidden="true" data-id="element-175" data-mp="1gl6uykaab2ub" />
            Complete package
          </span>

          <div className="flex items-center gap-4 text-left" data-id="element-176" data-mp="17n4o3o3vdfz4">
            <img src={heroImage} alt="" aria-hidden="true" className="h-24 w-24 shrink-0 object-contain sm:h-28 sm:w-28" width={1254} height={1254} loading="lazy" decoding="async" data-id="element-177" data-mp="17opj1eu3j0xi" />
            <div data-id="element-178" data-mp="3sb9b4j9n7wxn">
              <h3 className="font-display text-lg font-bold leading-snug text-navy sm:text-2xl" data-id="element-179" data-mp="3sewzz5457v61">
                {productName}
              </h3>
              <p className="mt-1 text-xs leading-relaxed text-body sm:text-sm" data-id="element-180" data-mp="2nydxris54yc">
                Everything you need to plan, coach and manage your full season.
              </p>
            </div>
          </div>

          <div className="mt-4 rounded-xl bg-canvas px-4 py-3 text-left" data-id="element-181" data-mp="3otv6y5m6uvrn">
            <CheckList items={packageItems} columns={2} size="xs" className="!grid-cols-2 !gap-x-3 !gap-y-1.5" data-id="element-182" data-mp="3b2zvqmo7w2kw" />
          </div>

          <div className="mt-4 flex items-center justify-center gap-3" data-id="element-183" data-mp="3fv02axysltqg">
            <p className="text-left" data-id="element-184" data-mp="315u3vc7s47jm">
              <span className="block text-xs text-signal line-through" data-id="element-185" data-mp="316wtlgtd83xy">
                Value {fullPrice}
              </span>
              <span className="block text-sm font-semibold uppercase text-navy" data-id="element-186" data-mp="3622eccb17ckg">
                Today
              </span>
            </p>
            <p className="text-5xl font-extrabold leading-none text-gold-text sm:text-6xl" data-id="element-187" data-mp="2x409flo6fzrw">
              {price}
            </p>
            <p className="rounded-md bg-success/10 px-2 py-1 text-left text-[11px] font-bold leading-tight text-success" data-id="element-188" data-mp="2digrwk3s822g">
              Save {savings}
              <span className="block" data-id="element-189" data-mp="2mj4wypb76s37">{savingsPercent} off</span>
            </p>
          </div>

          <CtaButton size="large" className="mt-4 w-full" data-id="element-190" data-mp="2ih9w1lx6igpy">
            Get the complete system now
          </CtaButton>

          <ul className="mt-3 flex flex-wrap justify-center gap-x-3.5 gap-y-1" data-id="element-191" data-mp="2wfrgnarsfd3n">
            {security.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-1 text-[11px] text-body sm:text-xs" data-id="element-192" data-mp="2rfvlm112iw08">
                <Icon className="h-3.5 w-3.5" strokeWidth={2} aria-hidden="true" data-id="element-193" data-mp="368ffsc68pt5j" />
                {label}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}